import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-800 text-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading text-2xl tracking-wide">{SITE.name}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/80">
              {SITE.description}
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={`mailto:${SITE.email}`}
                className="flex h-9 items-center gap-2 rounded-md bg-background-50/10 px-3 text-sm text-background-50 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-mail-line"></i>
                {SITE.email}
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-lg tracking-wide text-accent-200">内容分类</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg tracking-wide text-accent-200">网站导航</h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-100/80 transition-colors hover:text-background-50">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-100/80 transition-colors hover:text-background-50">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-100/80 transition-colors hover:text-background-50">
                  搜索爆料
                </Link>
              </li>
              <li>
                <a
                  href="#site-faq"
                  className="text-sm text-background-100/80 transition-colors hover:text-background-50"
                >
                  常见问题
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 {SITE.name} 保留所有权利。</p>
          <p>本站内容为网络公开信息整理，仅供阅读与讨论，不代表对任何事件的定性。</p>
        </div>
      </div>
    </footer>
  );
}